import AutoReply from "../assets/icon/svg/auto-reply";
import Campaign from "../assets/icon/svg/campaign";
import ChatSuggestions from "../assets/icon/svg/chat-assistant/chat-suggestions";
import Content from "../assets/icon/svg/chat-assistant/content";
import DialogBox from "../assets/icon/svg/chat-assistant/dialog-box";
import Instagram from "../assets/icon/svg/chat-assistant/instagram";
import Messenger from "../assets/icon/svg/chat-assistant/messenger";
import Script from "../assets/icon/svg/chat-assistant/script";
import Status from "../assets/icon/svg/chat-assistant/status";
import ChatAssistant from "../assets/icon/svg/chat_assistant";
import Customer from "../assets/icon/svg/customer";
import GrowthTool from "../assets/icon/svg/growth_tool";
import Livestream from "../assets/icon/svg/livestream";
import Messaging from "../assets/icon/svg/messaging";
import News from "../assets/icon/svg/news";
import Orders from "../assets/icon/svg/orders";
import PostAndComment from "../assets/icon/svg/post_and_comment";
import ReportDashboard from "../assets/icon/svg/report_dashboard";
import SalesNews from "../assets/icon/svg/sales-news";
import { URL } from "./constants";

export const menus = [
   {
      icon: <Messaging />,
      name: 'inbox',
      tooltip: 'Hộp thoại',
      href: URL.INBOX,
      match: [
         URL.INBOX
      ]
   },
   // {
   //    icon: <Campaign />,
   //    name: 'campaign',
   //    href: '',
   //    match: []
   // },
   {
      icon: <ChatAssistant />,
      name: 'chat_ssistant',
      href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
      tooltip: 'Trợ lý chat',
      match: [
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_INSTAGRAM,
         URL.CHAT_ASSISTANT_CONVERSATION_GENERAL,
         URL.CHAT_ASSISTANT_CONVERSATION_COMMENT,
         URL.CHAT_ASSISTANT_CONVERSATION_TAGLIST,
         URL.CHAT_ASSISTANT_CONVERSATION_TAGFOLDER,
         URL.CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION,
         URL.CHAT_ASSISTANT_SETUP_KEYWORD,
         URL.CHAT_ASSISTANT_SETUP_REF,
         URL.CHAT_ASSISTANT_SETUP_SEQUENCE,
         URL.CHAT_ASSISTANT_SETUP_TRIGGER,
         URL.CHAT_ASSISTANT_CONTENT_FLOW,
         URL.CHAT_ASSISTANT_CHAT_HINT,
         URL.CHAT_ASSISTANT_CONNECTION_STATUS,
      ]
   },
   {
      icon: <Customer />,
      name: 'customer',
      tooltip: "Khách hàng",
      href: URL.CUSTOMER_ALL,
      match: [
         URL.CUSTOMER_ALL
      ]
   },
   // {
   //    icon: <ReportDashboard />,
   //    name: 'upload_video',
   //    tooltip: "Upload Video",
   //    href: URL.UPLOAD_VIDEO,
   //    match: [
   //       URL.UPLOAD_VIDEO
   //    ]
   // },
   // {
   //    icon: <Livestream />,
   //    name: 'live_video_on_page',
   //    tooltip: "Live Video On Page",
   //    href: URL.LIVE_VIDEO_ON_PAGE,
   //    match: [
   //       URL.LIVE_VIDEO_ON_PAGE
   //    ]
   // },
   // {
   //    icon: <GrowthTool />,
   //    name: 'growth_tool',
   //    href: '',
   //    match: []
   // },
   {
      icon: <PostAndComment />,
      name: 'post_and_comment',
      href: URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST,
      tooltip: 'Bài viết & bình luận',
      match: [
         URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST,
         URL.POSTS_COMMENTS_SALE_POSTS_SETTING,
         URL.POSTS_COMMENTS_POSTS_POSTS_LIST,
         URL.POSTS_COMMENTS_POSTS_POSTS_LIST_EDIT,
         URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_EDIT,
         URL.POSTS_COMMENTS_SALE_POSTS_SETTING_CAMPAIGN
      ]
   },
   {
      icon: <Livestream />,
      name: 'livestream',
      tooltip: 'Livestream',
      href: URL.LIVESTREAM_LIVE_CAMPAIGN_LIST,
      match: [
         URL.LIVESTREAM_LIVE_CAMPAIGN_LIST,
         URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_DEFAULT_SETTINGS,
         URL.LIVESTREAM_LIVE_CAMPAIGN_LIST_EDIT
      ]
   },
   {
      icon: <Orders />,
      name: 'orders',
      tooltip: 'Quản lý công việc',
      href: URL.TASK_MANAGEMENT,
      match: [
         URL.TASK_MANAGEMENT
      ]
   },
   // {
   //    icon: <ReportDashboard />,
   //    name: 'report_dashboard',
   //    href: '',
   //    match: []
   // }
];

export const subMenus = [
   {
      match: [
         URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST,
         URL.POSTS_COMMENTS_POSTS_POSTS_LIST,
         URL.POSTS_COMMENTS_POSTS_POSTS_LIST_EDIT,
         URL.POSTS_COMMENTS_AUTOCOMMENT_KEYWORD
      ],
      title: "Bài viết & Bình luận",
      menus: [
         {
            name: "Tin bán hàng",
            href: URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST,
            match: [URL.POSTS_COMMENTS_SALE_POSTS_CAMPAIGN_LIST],
            icon: <SalesNews />
         },
         {
            name: "Bài viết",
            href: URL.POSTS_COMMENTS_POSTS_POSTS_LIST,
            match: [
               URL.POSTS_COMMENTS_POSTS_POSTS_LIST,
               URL.POSTS_COMMENTS_POSTS_POSTS_LIST_EDIT
            ],
            icon: <News />,

         },
         // {
         //    name: "Tự động trả lời",
         //    href: URL.POSTS_COMMENTS_AUTOCOMMENT_KEYWORD,
         //    match: [URL.POSTS_COMMENTS_AUTOCOMMENT_KEYWORD],
         //    icon: <AutoReply />
         // }
      ]
   },
   {
      match: [
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE,
         URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_INSTAGRAM,
         URL.CHAT_ASSISTANT_CONVERSATION_GENERAL,
         URL.CHAT_ASSISTANT_CONVERSATION_COMMENT,
         URL.CHAT_ASSISTANT_CONVERSATION_TAGLIST,
         URL.CHAT_ASSISTANT_CONVERSATION_TAGFOLDER,
         URL.CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION,
         URL.CHAT_ASSISTANT_SETUP_KEYWORD,
         URL.CHAT_ASSISTANT_SETUP_REF,
         URL.CHAT_ASSISTANT_SETUP_SEQUENCE,
         URL.CHAT_ASSISTANT_SETUP_TRIGGER,
         URL.CHAT_ASSISTANT_CONTENT_FLOW,
         URL.CHAT_ASSISTANT_CHAT_HINT,
         URL.CHAT_ASSISTANT_CONNECTION_STATUS,
      ],
      title: "Trợ lý chat",
      menus: [
         {
            name: "Cài đặt Messsenger",
            href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
            match: [
               URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
               URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ,
               URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU,
               URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY,
               URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE,
               URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT,
            ],
            icon: <Messenger />,
            subMenus: [
               {
                  name: "Cấu hình chung",
                  href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL,
                  match: [URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_GENERAL],
               },
               {
                  name: "Câu hỏi thường gặp",
                  href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ,
                  match: [
                     URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ,
                     URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT
                  ],
               },
               // {
               //    name: "Menu chính",
               //    href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU,
               //    match: [URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_MAINMENU],
               // },
               // {
               //    name: "Tin nhắn mặc định",
               //    href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY,
               //    match: [URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_DEFAULTREPLY],
               // },
               // {
               //    name: "Tin nhắn mở đầu",
               //    href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE,
               //    match: [URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_WELCOMEMESSAGE],
               // },
            ]
         },
         // {
         //    name: "Cài đặt Instagram",
         //    href: URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_INSTAGRAM,
         //    match: [
         //       URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_INSTAGRAM
         //    ],
         //    icon: <Instagram />,
         // },
         // {
         //    name: "Hội thoại",
         //    href: URL.CHAT_ASSISTANT_CONVERSATION_GENERAL,
         //    match: [URL.CHAT_ASSISTANT_CONVERSATION_GENERAL,
         //    URL.CHAT_ASSISTANT_CONVERSATION_COMMENT,
         //    URL.CHAT_ASSISTANT_CONVERSATION_TAGLIST,
         //    URL.CHAT_ASSISTANT_CONVERSATION_TAGFOLDER,
         //    URL.CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION

         //    ],
         //    icon: <DialogBox />,
         //    subMenus: [
         //       {
         //          name: "Cấu hình chung",
         //          href: URL.CHAT_ASSISTANT_CONVERSATION_GENERAL,
         //          match: [URL.CHAT_ASSISTANT_CONVERSATION_GENERAL],
         //       },

         //       {
         //          name: "Bình luận",
         //          href: URL.CHAT_ASSISTANT_CONVERSATION_COMMENT,
         //          match: [URL.CHAT_ASSISTANT_CONVERSATION_COMMENT],
         //       },
         //       {
         //          name: "Danh sách nhãn",
         //          href: URL.CHAT_ASSISTANT_CONVERSATION_TAGLIST,
         //          match: [URL.CHAT_ASSISTANT_CONVERSATION_TAGLIST],
         //       },
         //       {
         //          name: "Thư mục nhãn",
         //          href: URL.CHAT_ASSISTANT_CONVERSATION_TAGFOLDER,
         //          match: [URL.CHAT_ASSISTANT_CONVERSATION_TAGFOLDER],
         //       },
         //       {
         //          name: "Tiện ích nhãn",
         //          href: URL.CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION,
         //          match: [URL.CHAT_ASSISTANT_CONVERSATION_TAGEXTENSION],
         //       }
         //    ]
         // },
         // {
         //    name: "Kịch bản",
         //    href: URL.CHAT_ASSISTANT_SETUP_KEYWORD,
         //    match: [URL.CHAT_ASSISTANT_SETUP_KEYWORD,
         //    URL.CHAT_ASSISTANT_SETUP_REF,
         //    URL.CHAT_ASSISTANT_SETUP_SEQUENCE,
         //    URL.CHAT_ASSISTANT_SETUP_TRIGGER

         //    ],
         //    icon: <Script />,
         //    subMenus: [
         //       {
         //          name: "Trả lời theo từ khóa",
         //          href: URL.CHAT_ASSISTANT_SETUP_KEYWORD,
         //          match: [URL.CHAT_ASSISTANT_SETUP_KEYWORD],
         //       },

         //       {
         //          name: "Đường dẫn Ref",
         //          href: URL.CHAT_ASSISTANT_SETUP_REF,
         //          match: [URL.CHAT_ASSISTANT_SETUP_REF],
         //       },
         //       {
         //          name: "Kịch bản chăm sóc",
         //          href: URL.CHAT_ASSISTANT_SETUP_SEQUENCE,
         //          match: [URL.CHAT_ASSISTANT_SETUP_SEQUENCE],
         //       },
         //       {
         //          name: "Xử lí theo điều kiện",
         //          href: URL.CHAT_ASSISTANT_SETUP_TRIGGER,
         //          match: [URL.CHAT_ASSISTANT_SETUP_TRIGGER],
         //       },
         //    ]
         // },
         // {
         //    name: "Nội dung",
         //    href: URL.CHAT_ASSISTANT_CONTENT_FLOW,
         //    match: [URL.CHAT_ASSISTANT_CONTENT_FLOW],
         //    icon: <Content />
         // },
         // {
         //    name: "Gợi ý chat",
         //    href: URL.CHAT_ASSISTANT_CHAT_HINT,
         //    match: [URL.CHAT_ASSISTANT_CHAT_HINT],
         //    icon: <ChatSuggestions />
         // },
         // {
         //    name: "Trạng thái kết nối trang",
         //    href: URL.CHAT_ASSISTANT_CONNECTION_STATUS,
         //    match: [URL.CHAT_ASSISTANT_CONNECTION_STATUS],
         //    icon: <Status />
         // }
      ]
   },
];